<!-- ============================================================================= -->
<!-- Ella Custom JS - Customize The Style For Layout -->
<!-- ============================================================================= -->

<!-- ============================================================================= -->
<!-- IMPORTANT DISCLAIMER -->
<!-- Please use only JS to style the layout. -->
<!-- ============================================================================= -->


  $(document).on('click','.gbbGreetingCardImageList .greetingCardImageAndDetailsWrapper',function(){
      console.log('click'); 
      $('html, body').animate({
        'scrollTop' : $(".gbbGiftMessageV2MainContent").position().top + 100
      });
  });


      $(document).on('click', '[data-wishlist]', (event) => {
                    event.preventDefault();
                    event.stopPropagation();

        if(!$('body').hasClass('suffix-template-wishlist')){
                    $('[data-wishlist-items-display]').removeClass('is-loaded');
                    
                    var $target = $(event.currentTarget),
                        id = $target.data('product-id'),
                        handle = $target.data('wishlist-handle'),
                        wishlistList = localStorage.getItem('wishlistItem') ? JSON.parse(localStorage.getItem('wishlistItem')) : [];
                        index = wishlistList.indexOf(handle),
                        wishlistContainer = $('[data-wishlist-container]');
                      // console.log('clicked');
                    if(!$target.hasClass('wishlist-added')){
                        $target
                            .addClass('wishlist-added')
                            .find('.text')
                            .text(window.wishlist.added);
                          // console.log('clas adddeddd');
                      
                        if(wishlistContainer.length > 0) {
                            halo.setProductForWishlistPage(handle);
                        }

                        wishlistList.push(handle);
                        localStorage.setItem('wishlistItem', JSON.stringify(wishlistList));
                    } else {
                        $target
                            .removeClass('wishlist-added')
                            .find('.text')
                            .text(window.wishlist.add);
                            // console.log('clas removeddd');

                        if(wishlistContainer.length > 0) {
                            if($('[data-wishlist-added="wishlist-'+ id +'"]').length > 0) {
                                $('[data-wishlist-added="wishlist-'+ id +'"]').remove();
                            }
                        }
                      
                        wishlistList.splice(index, 1);
                        localStorage.setItem('wishlistItem', JSON.stringify(wishlistList));
                        halo.wishlistPagination();                         

                        if(wishlistContainer.length > 0) {
                            wishlistList = localStorage.getItem('wishlistItem') ? JSON.parse(localStorage.getItem('wishlistItem')) : [];

                            if (wishlistList.length > 0) {
                                halo.updateShareWishlistViaMail();
                            } else {
                                $('[data-wishlist-container]')
                                    .addClass('is-empty')
                                    .html(`\
                                    <div class="wishlist-content-empty text-center">\
                                        <span class="wishlist-content-text">${window.wishlist.empty}</span>\
                                        <div class="wishlist-content-actions">\
                                            <a class="button button-2 button-continue" href="${window.routes.collection_all}">\
                                                ${window.wishlist.continue_shopping}\
                                            </a>\
                                        </div>\
                                    </div>\
                                `);

                                $('[data-wishlist-footer]').hide();
                            }   
                        }
                    }
                    $('[data-wishlist-count]').text(wishlistList.length);
                    halo.setProductForWishlist(handle);
        }
    });


document.addEventListener("click", async function (e) {
  const btn = e.target.closest('product-form button[type="submit"]');
  if (!btn) return;

  const checkbox = document.getElementById("gift-addon-checkbox");
  const giftBox = document.querySelector(".gift-addon-box");

  if (!checkbox || !giftBox || !checkbox.checked) return;

  const giftVariantId = Number(giftBox.dataset.giftVariantId);

  // Main product add hone ke baad Gift Bag add karo
  setTimeout(async () => {
    try {
      await fetch("/cart/add.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify({
          id: giftVariantId,
          quantity: 1
        })
      });

      document.dispatchEvent(new CustomEvent("cart:refresh"));
    } catch (err) {
      console.error("Gift Bag Error:", err);
    }
  }, 700);
});



document.addEventListener("DOMContentLoaded", async () => {
  const giftBox = document.querySelector(".gift-addon-box");
  const checkbox = document.getElementById("gift-addon-checkbox");

  if (!giftBox || !checkbox) return;

  const giftVariantId = Number(giftBox.dataset.giftVariantId);

  try {
    // Cart load karke check karega ki Gift Bag pehle se add hai ya nahi
    const cart = await fetch("/cart.js").then((res) => res.json());

    const giftItem = cart.items.find(
      (item) => item.variant_id === giftVariantId
    );

    if (giftItem) {
      checkbox.checked = true;
    }

    checkbox.addEventListener("change", async () => {
      try {
        if (checkbox.checked) {
          // Gift Bag add
          await fetch("/cart/add.js", {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify({
              id: giftVariantId,
              quantity: 1,
            }),
          });
        } else {
          // Gift Bag remove
          const latestCart = await fetch("/cart.js").then((res) => res.json());

          const existingGift = latestCart.items.find(
            (item) => item.variant_id === giftVariantId
          );

          if (existingGift) {
            await fetch("/cart/change.js", {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
              },
              body: JSON.stringify({
                id: existingGift.key,
                quantity: 0,
              }),
            });
          }
        }

        // Cart refresh
        window.location.reload();
      } catch (error) {
        console.error("Gift Bag Error:", error);
      }
    });
  } catch (error) {
    console.error("Cart Error:", error);
  }
});
